import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStoreModel from '../_reducers/storeModel';

export const selectStoreModelState =
  createFeatureSelector<fromStoreModel.StoreModelState>('storeModels');

export const selectAllStoreModels = createSelector(selectStoreModelState, fromStoreModel.selectAll);

export const selectStoreModelsWithStatus = createSelector(selectStoreModelState, (state) => ({
  loaded: state.loaded,
  loading: state.loading,
  error: state.error,
  storeModels: fromStoreModel.selectAll(state),
}));
